import axios from "axios";
function fetchToken(username, password) {
    return axios.post(`https://backsc.osc-fr1.scalingo.io/api/login_check`,
        {
            "username": username,
            "password": password
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

export default { fetchToken }
